
import { Link } from 'react-router-dom';
import { Menu, X, Flag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetClose,
} from "@/components/ui/sheet";
import MobileNavLink from './MobileNavLink';

const NavbarBurgerMenu = () => {
  const { user, isAdmin, isCompany, logout } = useAuth();
  
  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9 p-0">
          <Menu className="h-5 w-5" />
          <span className="sr-only">Toggle Menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[400px]">
        <div className="flex flex-col gap-6 py-6">
          <div className="flex items-center justify-between border-b pb-4">
            <Link to="/" className="flex items-center gap-2">
              <Flag className="w-5 h-5 text-redflags-red" />
              <span className="font-medium text-lg">RedFlags</span>
            </Link>
            <SheetClose className="rounded-full hover:bg-slate-100 p-2">
              <X className="h-4 w-4" />
            </SheetClose>
          </div>
          
          <div className="flex flex-col gap-4">
            <MobileNavLink to="/">Home</MobileNavLink>
            <MobileNavLink to="/claim-company">Claim Company Profile</MobileNavLink>
            <a 
              href="https://greenflags.com.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="px-4 py-2 text-redflags-gray hover:text-redflags-dark rounded-md text-base"
            >
              Jobs
            </a>
            <MobileNavLink to="/recruiter-login">Recruiter Log In</MobileNavLink>
            <MobileNavLink to="/company-login">Company Login</MobileNavLink>
            {!user && <MobileNavLink to="/login">Log in</MobileNavLink>}
            {isAdmin && <MobileNavLink to="/admin/dashboard">Admin Dashboard</MobileNavLink>}
            {isCompany && <MobileNavLink to="/company-dashboard">Company Dashboard</MobileNavLink>}
            {user && (
              <button 
                onClick={logout}
                className="w-full text-left px-4 py-2 text-redflags-gray hover:text-redflags-dark rounded-md text-base"
              >
                Log out
              </button>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default NavbarBurgerMenu;
